import { derived, writable } from 'svelte/store';
import {applySearchParam} from "../utils/searchParams/applySearchParam.js";

export function initTableStore() {
  const ItemsPerPage = writable(10);  // the number of items displayed on the page
  const StyleName = writable("");  // the name of the displayed style
  const setStyleName = (name) => StyleName.set(name)
  const Styles = writable([]);  // list of available style names

  const StyleIndex = derived([StyleName, Styles], ([StyleName, Styles]) => {
    // when no style is available, return the default value.
    if (!Styles || Styles.length < 1) return 1

    // when the style of the specified name is found, return the index of the style.
    const style = Styles.find(style => style[0] === StyleName);
    if (style) return style[1]

    // else return the default value, and update StyleName to a valid name
    setStyleName(Styles[0][0])
    return 1
  });  // the index of the displayed style (1-indexed), defaults to 1.

  return {
    ItemsPerPage,
    StyleIndex,
    StyleName,
    Styles,
  }
}

export function connectSearchParamsToTableStore(TableStore, searchParams = new URLSearchParams(window.location.search)) {
  if (searchParams.get("style")) {
    TableStore.StyleName.set(searchParams.get("style"))
  }

  return [
    TableStore.StyleName.subscribe(val => {
      applySearchParam("style", val)
    }),
  ]
}
